export default __webpack_public_path__ + "src/docs/packages/kruger-sunset-lodge.pdf";